import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { open } from '../../../../modules/modal/actions';

const mapDispatchToProps = {
  showCashInInfo: open.bind(null, { componentName: 'CashInInfo' })
};

const CashInFailed = ({ showCashInInfo }) => (
  <div>
    Cash out could not be completed.{' '}
    <span className="open-bet-single-message__link" onClick={showCashInInfo}>
      More information
    </span>
  </div>
);

CashInFailed.propTypes = {
  showCashInInfo: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(CashInFailed);
